import React from 'react';
import { CustomButton } from '../../../components/buttons/customButton';
import { mondayIntegrationUrl } from '../../../constants/integrationConstants';

const MondayPanel = () => (
  <div className="flex justify-between gap-5 rounded-xl border p-4">
    <div className="flex flex-col gap-2 text-primary">
      <span className="text-sm font-semibold">Connect to Monday.com</span>
      <p className="text-sm font-normal">
        Link your Monday.com account with our platform for more efficient tracking.
      </p>
    </div>
    <CustomButton
      type="button"
      onClick={() => window.location.replace(mondayIntegrationUrl)}
    >
      Connect to Monday.com
    </CustomButton>
  </div>
);

export default MondayPanel;

